import { format } from "date-fns";

// RFC 5545 text escaping. Dish names are user input, and an unescaped newline
// or colon in one would terminate the property early - at best the event
// imports with a mangled title, at worst the user can inject extra calendar
// properties into their own export.
const escapeText = (value) =>
  String(value ?? "")
    .replace(/\\/g, "\\\\")
    .replace(/;/g, "\\;")
    .replace(/,/g, "\\,")
    .replace(/\r?\n/g, "\\n");

// Content lines must be folded at 75 octets, with continuations starting with
// a single space.
const foldLine = (line) => line.replace(/(.{74})/g, "$1\r\n ");

const buildLine = (name, value) => foldLine(`${name}:${escapeText(value)}`);

export const generateICSFile = (menu, weekdays) => {
  const nextMonday = (() => {
    const today = new Date();
    const daysUntilMonday = (8 - today.getDay()) % 7 || 7;
    const monday = new Date(today);
    monday.setDate(today.getDate() + daysUntilMonday);
    return monday;
  })();

  const stamp = format(new Date(), "yyyyMMdd'T'HHmmss");

  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "CALSCALE:GREGORIAN",
    "PRODID:-//FoodPlanner//Weekly Menu//EN",
  ];

  menu.forEach((dish, index) => {
    if (!dish) return;

    const eventDate = new Date(nextMonday);
    eventDate.setDate(nextMonday.getDate() + index);
    const formattedDate = format(eventDate, "yyyyMMdd");

    const description = `Day: ${weekdays[index]} | Ingredient: ${
      dish.MainIngredient || "Unknown"
    } | Category: ${dish.Category || "Unknown"}${
      dish.RecipeUrl ? ` | Recipe: ${dish.RecipeUrl}` : ""
    }${dish.sides ? ` | Sides: ${dish.sides}` : ""}`;

    lines.push(
      "BEGIN:VEVENT",
      // Calendar clients use UID to de-duplicate; without it, re-importing a
      // week creates a second copy of every dinner.
      `UID:${formattedDate}-${index}-foodplanner@foodplanner.io`,
      `DTSTAMP:${stamp}`,
      buildLine("SUMMARY", dish.Name),
      buildLine("DESCRIPTION", description),
      `DTSTART:${formattedDate}T160000`,
      `DTEND:${formattedDate}T170000`,
      "END:VEVENT"
    );
  });

  lines.push("END:VCALENDAR");

  const blob = new Blob([lines.join("\r\n")], {
    type: "text/calendar;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "WeeklyMenu.ics";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
